module.exports = __webpack_public_path__ + "img/Flip Card 1.f9e6cbbe.svg";